export default __webpack_public_path__ + "static/media/user_agreement.310d0409.md";